import { createSelector } from 'reselect';
import { AppState } from 'store/AppState';
import { BookingState, BookingStatus } from './booking-types';

export const bookingSelector = (state: AppState): BookingState => state.booking;

export const getBookingForm = createSelector(bookingSelector, (booking) => booking.form);

export const getBookingStatus = (state: AppState): BookingStatus => state.booking.status;
